<script>
    import Home from './home.svelte'
    import Teams from './teams.svelte'
    import News from './news.svelte'
    import Events from './events.svelte'
    import More from './more.svelte'

    export let fill
</script>

<style>
    .bottom-button-bar {
        position: absolute;
        bottom: 28px;
        height: 50px;
        width: 100%;

        display: flex;
        flex-direction: row;
        justify-content: space-around;
    }
</style>

<div class="bottom-button-bar">
    <Home {fill} />
    <Teams />
    <News />
    <Events />
    <More />
</div>
